import * as Long from "long";
import { selectResourceInfo } from "../balancingSelectors/selectBalancingResources";
var UtilOffers = /** @class */ (function () {
    function UtilOffers() {
        this.matchPurchaseOfferGroupToWebCatalog = function (offerGroup, packages, offerIndex) {
            if (offerIndex === void 0) { offerIndex = 0; }
            if (offerGroup === undefined || offerGroup.purchaseOffer[offerIndex] === undefined) {
                return;
            }
            var name = offerGroup.purchaseOffer[offerIndex].nameId;
            var numberToFind = parseInt(name.substr(name.length - 4), 10);
            return packages.find(function (item) { return item.price === numberToFind; });
        };
        this.convertOfferGroupToOffer = function (offerGroup, shopPackage, onCloseClick, onBuyClick, providers) {
            var offer = offerGroup.purchaseOffer[0];
            var rewards = [];
            (offer.resourceReward || []).forEach(function (element) {
                var resource = selectResourceInfo(element.resourceId);
                rewards.push({
                    amount: Long.fromValue(element.amount),
                    eventTypeIdRestriction: resource.eventTypeIdRestriction,
                    id: element.resourceId,
                    locaKey: resource.locaKey,
                    name: resource.name,
                    // TODO: this should be changed
                    tracked: true,
                });
            });
            // first value is removed because it is a double of the base gold value.
            rewards = rewards.slice(1);
            return {
                backgroundColor: offerGroup.backgroundColor,
                baseGoldValue: offer.baseGold || 0,
                bonusGoldPercent: offer.bonusGoldPercent || 0,
                bonusGoldValue: offer.bonusGoldValue || 0,
                imageName: offerGroup.imageName,
                locaKeyEyecatcher: offerGroup.locaKeyEyecatcher,
                locaKeyFlavour: offerGroup.locaKeyTitle,
                locaKeyTitle: offerGroup.locaKeyTitle,
                offerCharacteristicId: offerGroup.purchaseOfferCharacteristicId,
                onBuyClick: onBuyClick,
                onCloseClick: onCloseClick,
                providers: providers,
                purchaseOfferNameId: offer.nameId,
                purchasePoints: offer.purchasePoints,
                remainingSeconds: -1,
                rewards: rewards,
                shopPackage: shopPackage,
                webBonusGold: offer.webBonusGold,
            };
        };
    }
    return UtilOffers;
}());
export var utilOffers = new UtilOffers();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilOffers.ts
// module id = 965
// module chunks = 3